// removed by extract-text-webpack-plugin
module.exports = {"Stats":"GrabCV__Stats__1j_rJ","Cv":"GrabCV__Cv__jnr7D"};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/GrabCV/GrabCV.css
// module id = 118
// module chunks = 0